<template>
  <span v-if="multiDayEvent()">
    {{event.start | moment("MM/DD/YYYY")}}-{{event.end | moment("MM/DD/YYYY")}} {{event.title}}
  </span>
  <span v-else>
    {{event.start | moment("h:mma")}}-{{event.end | moment("h:mma")}} {{event.title}}
  </span>
</template>

<script>

export default {
  props: {
    event: {
      type: Object
    }
  },
  methods: {
    multiDayEvent(){
      return new Date(this.event.start).toDateString() != new Date(this.event.end).toDateString()
    }
  }
}
</script>
